<template>
  <svg
    id="Сгруппировать_3082"
    data-name="Сгруппировать 3082"
    xmlns="http://www.w3.org/2000/svg"
    width="84.546"
    height="39.913"
    viewBox="0 0 84.546 39.913"
  >
    <g
      id="Сгруппировать_3082-2"
      data-name="Сгруппировать 3082"
      transform="translate(0 0)"
    >
      <path
        id="Контур_3565"
        data-name="Контур 3565"
        d="M40.47,70.458c-.322.3-.648.588-.966.889a7.121,7.121,0,0,0-.947,9.714,5.77,5.77,0,0,0,2.454,2.031c.12.049.242.092.391.149-.134.365-.253.724-.4,1.073a18.7,18.7,0,0,1-3.42,5.548,8.249,8.249,0,0,1-.91.839,3.859,3.859,0,0,1-3.681.819c-.686-.2-1.364-.425-2.046-.636a7.931,7.931,0,0,0-2.157-.41,7.05,7.05,0,0,0-2.616.566,17.256,17.256,0,0,1-1.958.642,3.528,3.528,0,0,1-2.865-.662,8.516,8.516,0,0,1-2.171-2.23,22.788,22.788,0,0,1-3.356-7.011,16.271,16.271,0,0,1-.449-6.86,9.779,9.779,0,0,1,2.51-5.411,6.3,6.3,0,0,1,5.474-2.014,17.326,17.326,0,0,1,3.12.715c.428.124.865.218,1.3.328a3.412,3.412,0,0,0,1.826-.09c.843-.247,1.675-.528,2.517-.778a7.922,7.922,0,0,1,3.812-.228,7.215,7.215,0,0,1,4.1,2.479c.139.157.274.318.411.477A.334.334,0,0,1,40.47,70.458Z"
        transform="translate(-15.196 -60.169)"
      />
      <path
        id="Контур_3566"
        data-name="Контур 3566"
        d="M115.493,14.659a9.206,9.206,0,0,1,.045,1.054,7.541,7.541,0,0,1-2.143,4.8,5.71,5.71,0,0,1-2.009,1.454,7.026,7.026,0,0,1-2.1.375c-.011,0-.023-.011-.034-.017C109.35,18.177,111.445,15.493,115.493,14.659Z"
        transform="translate(-96.5 -14.659)"
      />
    </g>
    <g
      id="Сгруппировать_3083"
      data-name="Сгруппировать 3083"
      transform="translate(34.194 4.42)"
    >
      <path
        id="Контур_3567"
        data-name="Контур 3567"
        d="M267.412,47.778A39.767,39.767,0,0,1,274,47.265c3.392,0,5.876.789,7.453,2.208a7.146,7.146,0,0,1,2.327,5.561,7.824,7.824,0,0,1-2.051,5.679c-1.814,1.932-4.772,2.918-8.124,2.918a11.806,11.806,0,0,1-2.761-.237V74.042h-3.431Zm3.431,12.817a11.5,11.5,0,0,0,2.839.276c4.141,0,6.665-2.011,6.665-5.679,0-3.51-2.484-5.206-6.27-5.206a14.4,14.4,0,0,0-3.234.276Z"
        transform="translate(-267.412 -47.265)"
      />
      <path
        id="Контур_3568"
        data-name="Контур 3568"
        d="M402.5,120.309l-.276-2.406h-.118a7.109,7.109,0,0,1-5.836,2.839,5.438,5.438,0,0,1-5.837-5.482c0-4.614,4.1-7.138,11.476-7.1v-.394c0-1.577-.434-4.417-4.338-4.417a9.51,9.51,0,0,0-4.969,1.42l-.789-2.287a11.846,11.846,0,0,1,6.27-1.7c5.837,0,7.256,3.983,7.256,7.808v7.138a26.878,26.878,0,0,0,.315,4.575Zm-.513-9.741c-3.786-.079-8.084.592-8.084,4.3a3.071,3.071,0,0,0,3.273,3.313,4.749,4.749,0,0,0,4.614-3.194,3.62,3.62,0,0,0,.2-1.1Z"
        transform="translate(-373.755 -93.532)"
      />
      <path
        id="Контур_3569"
        data-name="Контур 3569"
        d="M510.251,103.987l4.18,11.279c.434,1.262.907,2.761,1.223,3.9h.079c.355-1.144.749-2.6,1.222-3.983l3.786-11.2h3.667L519.2,117.593c-2.484,6.546-4.18,9.9-6.546,11.949a9.4,9.4,0,0,1-4.259,2.248l-.868-2.918a9.177,9.177,0,0,0,3.037-1.7,10.524,10.524,0,0,0,2.918-3.865,2.491,2.491,0,0,0,.276-.828,3.018,3.018,0,0,0-.237-.907l-7.059-17.589Z"
        transform="translate(-474.056 -96.297)"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'Icon',
  }
</script>
